/* 搜索管理 */
import request from '../utils/request'
import Mock from 'mockjs'

/* 获取联想关键词数据 */
export const getTopPicksAPI = () => {
	const result = Mock.mock({
		'list|10': [
			{
				'id|+1': 1,
				title: '@title(1, 5)',
				description: '@paragraph(5, 10)',
			},
		],
	})
	return result.list
	// return request({
	// 	url: '/search/getWordPrediction',
	// 	method: 'post',
	// 	data,
	// })
}

/* 获取搜索结果数据 */
export const getResultListAPI = data => {
	const result = Mock.mock({
		'list|6': [
			{
				'id|+1': 11,
				title: () => `${data} ${Mock.mock('@title(1, 5)')}`,
				description: '@paragraph(5, 10)',
			},
		],
	})
	return result.list
	// return request({
	// 	url: '/search/getResultList',
	// 	method: 'post',
	// 	data,
	// })
}

/* 获取促销活动通知个项详情 */
export const getResultItemAPI = id => {
	const result = Mock.mock({
		'id|+1': id,
		title: '@title(5, 10)',
		subtitle: '@title(5, 10)',
		description1: '@paragraph(5, 10)',
		description2: '@paragraph(5, 10)',
		author: '@name(1, 2)',
		date: '@datetime("yyyy-MM-dd HH:mm:ss")',
		codeString: `
	/**
	 *  If original language is selected, then the value of current_language
	 * will be empty. Otherwise, it will contain the current selected
	 * language code.
	 *
	 */
	var current_language = gt_get_cookie('googtrans').split('/').pop()

	// W3 Schools: https://www.w3schools.com/js/js_cookies.asp
	function gt_get_cookie(cname) {
		var name = cname + '='
		var decodedCookie = decodeURIComponent(document.cookie)
		var ca = decodedCookie.split(';')
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i]
			while (c.charAt(0) == ' ') {
				c = c.substring(1)
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length)
			}
		}
		return ''
	}
		`,
	})
	return result
	// return request({
	// 	url: `/notice/getPromotionItem/${id}`,
	// 	method: 'post',
	// })
}
